import React, { useState, useEffect } from 'react';
import { Alert, AlertTitle, Box, Button } from '@mui/material';
import { Warning as WarningIcon, Storage as StorageIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import api from '../api/api';

const RecordatorioBackup = () => {
  const navigate = useNavigate();
  const [mostrarAlerta, setMostrarAlerta] = useState(false);

  useEffect(() => {
    const verificarUltimoBackup = async () => {
      try {
        const res = await api.get('/backup/listar');
        const respaldos = Array.isArray(res.data) ? res.data : [];

        if (respaldos.length === 0) {
          // Si no hay ningún respaldo, se muestra la alerta
          setMostrarAlerta(true);
          return;
        }

        // Tomar la fecha del respaldo más reciente
        const ultimaFechaStr = respaldos[0].fecha_creacion; // Formato esperado "YYYY-MM-DD HH:mm:ss"
        const fechaUltimoBackup = new Date(ultimaFechaStr.replace(' ', 'T'));
        const hoy = new Date();

        // Calcular la diferencia en días
        const diferenciaMs = hoy - fechaUltimoBackup;
        const diasDiferencia = diferenciaMs / (1000 * 60 * 60 * 24);

        // Se muestra la alerta únicamente si han transcurrido 7 o más días  para pruebas puedes setear a cero
        if (diasDiferencia >= 6) {
          setMostrarAlerta(true);
        } else {
          setMostrarAlerta(false);
        }
      } catch (err) {
        console.error('Error verificando la última copia de seguridad:', err);
      }
    };

    verificarUltimoBackup();
  }, []);

  if (!mostrarAlerta) return null;

  return (
    <Box sx={{ mb: 3 }}>
      <Alert
        severity="warning"
        icon={<WarningIcon fontSize="inherit" />}
        action={
          <Button
            color="inherit"
            size="small"
            variant="outlined"
            startIcon={<StorageIcon />}
            onClick={() => navigate('/respaldosmiu')}
            sx={{
              fontWeight: 'bold',
              borderColor: '#c2410c',
              color: '#9a3412',
              '&:hover': { bgcolor: 'rgba(234, 88, 12, 0.1)' }
            }}
          >
            Ir a Respaldos
          </Button>
        }
        sx={{
          bgcolor: '#fff7ed', // Fondo naranja suave
          color: '#9a3412',   // Texto naranja oscuro
          border: '1px solid #ffedd5',
          borderLeft: '6px solid #f97316', // Borde naranja vivo
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(249, 115, 22, 0.15)',
          '& .MuiAlert-icon': { color: '#ea580c' }
        }}
      >
        <AlertTitle sx={{ fontWeight: 700, fontSize: '15px' }}>
          ¡Atención! Copia de seguridad requerida
        </AlertTitle>
        «Recuerda realizar tu copia de seguridad semanalmente. Proteger tu información es fundamental, y al hacerlo cada 7 días, te aseguras de no perder datos importantes. Es un proceso breve y sencillo.»
      </Alert>
    </Box>
  );
};

export default RecordatorioBackup;